module.exports = __webpack_public_path__ + "static/media/heldane-text-web-medium.628470eb.woff2";